import { render, staticRenderFns } from "./AuthWithFacebook.vue?vue&type=template&id=a2bbc658&"
import script from "./AuthWithFacebook.vue?vue&type=script&lang=js&"
export * from "./AuthWithFacebook.vue?vue&type=script&lang=js&"
import style0 from "./AuthWithFacebook.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports